import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const OrganizationsPageContainer = lazy(() =>
    import(/* webpackChunkName: "organization" */ '@organization/ui/OrganizationListPage').then(m => ({
        default: m.OrganizationsPage,
    })),
);
const LegalEntityPage = lazy(() =>
    import(/* webpackChunkName: "organization" */ '@organization/ui/LegalEntityPage').then(m => ({
        default: m.LegalEntityPage,
    })),
);
const OrganizationPageContainer = lazy(() =>
    import(/* webpackChunkName: "organization" */ '@organization/ui/OrganizationPage').then(m => ({
        default: m.OrganizationPage,
    })),
);
export const organizationLocations: Location[] = [
    {
        url: '/organization',
        Component: OrganizationsPageContainer,
    },
    {
        url: '/organization/:organizationId',
        Component: OrganizationPageContainer,
    },
    {
        url: '/legal-entity/:legalEntityId',
        Component: LegalEntityPage,
    },
];
